import { breakpoints } from "../helpers/breakpoints";

export const observer = new IntersectionObserver(
  (entries) => {
    if (window.innerWidth >= breakpoints.screen1024) {
      entries.forEach((entry) => {
        const animationType = entry.target.getAttribute("js-animate");
        if (entry.isIntersecting) {
          entry.target.classList.add(`animate--${animationType}`);
        }
      });
    }
  },
  { threshold: 0 }
);

export const animate = () => {
  const hiddenElements = document.querySelectorAll("[js-animate]");
  hiddenElements.forEach((el) => observer.observe(el));
};
